// import { Location } from 'vue-router';
import FormButton from '@/components/ext/Button.vue';
import PanelDashed from './dashed';
import MessageNotification from './notification';

export default {
  components: {
    FormButton,
    MessageNotification,
    PanelDashed,
  },

  props: {
    buttonText: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: [String, Object /* Location */],
      default: null,
    },
    hideButton: {
      type: Boolean,
      default: false,
    },
    messages: {
      type: [Array, Object],
      default: null,
    },
    width: {
      type: String,
      default: '50%'
    }
  },

  computed: {
    formActionResolved() {
      const { $router, formAction } = this;
      return (typeof Location !== typeof undefined && formAction instanceof Location) ? $router.resolve(formAction).href : formAction;
    },

    messagesList() {
      const { messages } = this;

      if (!messages) {
        return [];
      }

      return Array.isArray(messages) ? messages : [ messages ];
    },

    hasMessages() {
      const { messagesList } = this;
      return messagesList.length > 0;
    },

    buttonColor() {
      const { disabled } = this;
      return disabled ? 'disabled' : 'green';
    },
  },

  methods: {
    submit(event) {
      event.preventDefault();
      this.$emit('submit');
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/markup/popup/form/component.js